if (!customElements.get('sheworks-blog-rail')) {
  customElements.define('sheworks-blog-rail', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.sw-blog-rail');
      this.controls = this.querySelector('.sw-blog-controls');
      if (!this.rail || !this.controls) return;
      this.onScroll = () => this.updateControls();
      this.onClick = (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button || !this.controls.contains(button)) return;
        const card = this.rail.querySelector('.sw-story');
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap);
        this.rail.scrollBy({ left: button.dataset.direction === 'next' ? step : -step,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      this.controls.addEventListener('click', this.onClick);
      this.observer = new ResizeObserver(this.onScroll);
      this.observer.observe(this.rail);
      this.updateControls();
    }
    updateControls() {
      const image = this.rail.querySelector('.sw-story-image');
      if (image) this.style.setProperty('--sw-control-top', `${Math.max(0, image.getBoundingClientRect().height - 24)}px`);
      const end = this.rail.scrollWidth - this.rail.clientWidth;
      this.controls.hidden = end <= 2;
      this.controls.querySelector('[data-direction="previous"]').disabled = this.rail.scrollLeft <= 2;
      this.controls.querySelector('[data-direction="next"]').disabled = this.rail.scrollLeft >= end - 2;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.rail?.removeEventListener('scroll', this.onScroll);
      this.controls?.removeEventListener('click', this.onClick);
    }
  });
}
